import { isDefined } from "@omni/utils/helper.utils";
import { useEffect, useState } from "react";

import { EcornerService } from "@/services/eCorner.service";

export const useIsECorner = () => {
    const [isECorner, setIsECorner] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        EcornerService.isEcornerEnvironment().then(setIsECorner);
    }, []);

    return {
        isECorner: isECorner,
        loading: !isDefined(isECorner)
    };
};
